import React from "react";
import { Icon } from "semantic-ui-react";

export const EditRecordIcon = () => (
  <Icon name="unlock alternate" className="neutral" />
);
export const DeleteRecordIcon = () => (
  <Icon name="delete" className="neutral" />
);
export const PublishRecordIcon = () => (
  <Icon name="upload" className="neutral" />
);

export const RecordNewVersionIcon = () => (
  <Icon name="plus" className="neutral" />
);

export const AssignDoiIcon = () => (
  <Icon name="drivers license" className="neutral" />
);
